import React from 'react';
import { MessageCircle } from 'lucide-react';
import './WhatsAppFloat.css';

const WhatsAppFloat = () => {
  const openWhatsApp = () => {
    const text = 'Hello RV Physio Therapy, I would like to book a physiotherapy appointment.';
    const whatsappUrl = `https://web.whatsapp.com/send?phone=917048944596&text=${encodeURIComponent(text)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="whatsapp-float" onClick={openWhatsApp} aria-label="Chat on WhatsApp">
      <div className="whatsapp-label">Book on WhatsApp</div>
      <div className="whatsapp-btn">
        <MessageCircle size={28} fill="white" />
      </div>
    </div>
  );
};

export default WhatsAppFloat;
